// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3jZnx","content":"styles_content__1EKcm","selectAll":"styles_selectAll__1NdR2"};